export default "__VITE_ASSET__D89F8CfH__"